// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","678":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"223":"c6726477057a648e5a28","532":"9a44b0c96edc28263ac1","678":"d255c9d9a262d6bcf079","843":"4d22e4d87d98fa226c97"}[chunkId] + ".js";
};